import { clsx } from 'clsx';
import * as styles from './styles.css';
import { TThreeUtpBlock } from 'shared/types/utp';
import { useDeviceType } from '@cian/ui-kit';

type TThreeUtpBlockProps = { elements: TThreeUtpBlock };

export const ThreeUtpBlock: React.FC<TThreeUtpBlockProps> = ({ elements }) => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      {elements.map((item, key) => (
        <div key={key} className={clsx(styles['item'], styles[item.color])}>
          <div className={styles['title']}>{item.title}</div>
          <div className={styles['description']}>{item.description}</div>
        </div>
      ))}
    </div>
  );
};
